<template>
  <v-fade-transition>
    <wgu-module-card v-bind="$attrs" :moduleName="moduleName" :icon="icon" class="card" width=50% height=70%>
      <v-card-text class="pa-6" style="font-family: 'Open Sans';">
        <div>
          <h1>I. Informationen &uuml;ber die Verarbeitung Ihrer Daten gem&auml;&szlig; Art. 13 der
            Datenschutz-Grundverordnung (DS-GVO)</h1>
          <h2>1. Verantwortlich f&uuml;r die Webseite und mit dem Datenschutz beauftragt</h2>
          <p>Die Vorst&auml;ndin Frau Dipl.-Ing. Ulrike Franzke<br /> Stadtentw&auml;sserungsbetriebe K&ouml;ln, Anstalt
            des &ouml;ffentlichen Rechts (StEB K&ouml;ln)<br /> Ostmerheimer Stra&szlig;e 555 51109 K&ouml;ln<br />
            Telefon: 0221 221-26868<br /> E-Mail: <a href="mailto:steb@steb-koeln.de">steb@steb-koeln.de</a></p>
          <p>Die f&uuml;r den Datenschutz beauftragte Person erreichen Sie per E-Mail unter:<br /><a
              href="mailto:dsb@steb-koeln.de">dsb@steb-koeln.de</a></p>
          <p>oder &uuml;ber die Adresse:<br /> Stadtentw&auml;sserungsbetriebe K&ouml;ln, Anstalt des &ouml;ffentlichen
            Rechts (StEB K&ouml;ln)<br /> Datenschutzbeauftragter<br /> Ostmerheimer Stra&szlig;e 555<br /> 51109
            K&ouml;ln</p>
          <h2>2. Daten, die f&uuml;r die Bereitstellung der Website und die Erstellung der Protokolldateien verarbeitet
            werden</h2>
          <h3>a. Welche Daten werden f&uuml;r welchen Zweck verarbeitet?</h3>
          <p>Bei jedem Zugriff auf Inhalte der Website werden vor&uuml;bergehend Daten gespeichert, die
            m&ouml;glicherweise eine Identifizierung zulassen. Die folgenden Daten werden hierbei erhoben:</p>
          <ul type="disc">
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>IP-Adresse</li>
            <li>Besuchte Seite auf unserer Website</li>
            <li>Meldung, ob der Abruf erfolgreich war</li>
            <li>Informationen &uuml;ber den Browsertyp und die verwendete Version</li>
            <li>Betriebssystem</li>
          </ul>
          <p>Die vor&uuml;bergehende Speicherung der Daten ist f&uuml;r den Ablauf eines Websitebesuchs erforderlich, um
            eine Auslieferung der Website zu erm&ouml;glichen. Eine weitere Speicherung in Protokolldateien erfolgt, um
            die Funktionsf&auml;higkeit der Website und die Sicherheit der informationstechnischen Systeme
            sicherzustellen. In diesen Zwecken liegt auch unser berechtigtes Interesse an der Datenverarbeitung.</p>
          <p>&nbsp;b. Auf welcher Rechtsgrundlage werden diese Daten verarbeitet?<br /> Die Daten werden auf der
            Grundlage des Art. 6 Abs. 1 Buchstabe f DS-GVO verarbeitet.</p>
          <h3>&nbsp;c. Folgende Datenverarbeitende Vorg&auml;nge werden auf der Webseite genutzt:</h3>
          <p>Bundesamt f&uuml;r Kartographie und Geod&auml;sie (BKG): Diese Internetpr&auml;senz verwendet Dienste des
            Bundesamtes f&uuml;r Kartographie und Geod&auml;sie (BKG), Richard-Strauss-Allee 11, 60598 Frankfurt am
            Main, Germany</p>
          <p>Diese Liste stellt die Zwecke der Datenerhebung und -verarbeitung dar:</p>
          <ul type="disc" style="padding-left: 4% !important">
            <li>Anzeige der Kartenhintergr&uuml;nde</li>
          </ul>
          <p>Diese Liste enth&auml;lt alle (pers&ouml;nlichen) Daten, die bei der oder durch die Nutzung des Service
            gesammelt werden:</p>
          <ul type="disc">
            <li>IP-Adresse</li>
            <li>Typ und Version Ihres Internet-Browsers</li>
            <li>verwendetes Betriebssystem</li>
            <li>die aufgerufene Seite</li>
            <li>die zuvor besuchte Seite (Referrer URL)</li>
            <li>Datum und Uhrzeit der Serveranfrage</li>
          </ul>
          <p>Im Folgenden wird die erforderliche Rechtsgrundlage f&uuml;r die Verarbeitung von Daten genannt: <br /> 6
            Abs. 1 S. 1 lit. c DSGVO</p>
          <p>Ort der Verarbeitung: <br /> Europ&auml;ische Union</p>
          <p>Die Daten werden &uuml;ber den Zeitpunkt des Besuches hinaus in den Logfiles des BKG Systems gespeichert.
            Das BKG ist auf Grundlage des Artikels 6 Absatz 1 Buchstabe e EU-Datenschutz- Grundverordnung (DSGVO) in
            Verbindung mit &sect; 5 BSI-Gesetz zur Speicherung der Daten - zum Schutz vor Angriffen auf die
            Internetinfrastruktur des BKG / Kommunikationstechnik des Bundes - &uuml;ber den Zeitpunkt Ihres Besuches
            hinaus verpflichtet. Diese Daten werden analysiert und im Falle von Angriffen auf die Kommunikationstechnik
            zur Einleitung einer Rechts- und Strafverfolgung ben&ouml;tigt. Eine Speicherung dieser Daten zusammen mit
            anderen personenbezogenen Daten des Nutzers findet nicht statt. Daten, die beim Zugriff auf das
            Internetangebot des BKG protokolliert wurden, werden an Dritte nur &uuml;bermittelt, soweit das BKG
            rechtlich dazu verpflichtet ist oder die Weitergabe im Falle von Angriffen auf die Kommunikationstechnik des
            Bundes zur Rechts- oder Strafverfolgung erforderlich ist. Eine Weitergabe in anderen F&auml;llen erfolgt
            nicht. Eine Zusammenf&uuml;hrung dieser Daten mit anderen Datenquellen wird durch das BKG nicht vorgenommen.
          </p>
          <p>Datenempf&auml;nger:</p>
          <p>Bundesamt f&uuml;r Kartographie und Geod&auml;sie (BKG)</p>
          <p>Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens:</p>
          <p><a href="mailto:dsb@bkg.bund.de">dsb@bkg.bund.de</a></p>
          <p>Klicken Sie hier, um die Datenschutzbestimmungen der datenverarbeitenden Stelle zu lesen: <a
              href="https://sg.geodatenzentrum.de/web_public/gdz/lizenz/deu/Datenschutzerklaerung_Webanwendungen.pdf">https://sg.geodatenzentrum.de/web_public/gdz/lizenz/deu/Datenschutzerklaerung_Webanwendungen.pdf</a>
          </p>
          <p>&nbsp;d. Gibt es neben den Verantwortlichen weitere Empf&auml;nger der personenbezogenen Daten?</p>
          <p>Die Webseite wird technisch von der geomer GbmH (Im Breitspiel 11b, 69126 Heidelberg;&nbsp;<a
              href="mailto:info@geomer.de">info@geomer.de</a>) betreut. <br /> Der Auftragnehmer empf&auml;ngt die oben
            genannten Daten als auftragsverarbeitende Stelle.</p>
          <p>Die Website wird bei Hetzner Online GmbH (Industriestr. 25, 91710 Gunzenhausen;&nbsp;<a
              href="mailto:info@hetzner.com">info@hetzner.com</a>) gehostet. <br /> Das Hostingunternehmen empf&auml;ngt
            die oben genannten Daten als auftragsverarbeitende Stelle.</p>
          <h3>&nbsp;e. Wie lange werden die Daten gespeichert?</h3>
          <p>Die Daten werden gel&ouml;scht, sobald sie f&uuml;r die Erreichung des Zwecks ihrer Erhebung nicht mehr
            erforderlich sind. Bei der Bereitstellung der Website ist dies der Fall, wenn die jeweilige Sitzung beendet
            ist. Die Protokolldateien werden 14 Tage direkt und ausschlie&szlig;lich f&uuml;r Administratoren
            zug&auml;nglich aufbewahrt.</p>
          <h2>3. Betroffenenrechte</h2>
          <p>a. Recht auf Auskunft</p>
          <p>Sie k&ouml;nnen Auskunft nach Art. 15 DS-GVO &uuml;ber Ihre personenbezogenen Daten verlangen, die wir
            verarbeiten.</p>
          <p>b. Recht auf Widerspruch</p>
          <p>Sie haben ein Recht auf Widerspruch aus besonderen Gr&uuml;nden (siehe unter Punkt II).</p>
          <p>c. Recht auf Berichtigung</p>
          <p>Sollten die Sie betreffenden Angaben nicht (mehr) zutreffend sein, k&ouml;nnen Sie nach Art. 16 DS-GVO eine
            Berichtigung verlangen. Sollten Ihre Daten unvollst&auml;ndig sein, k&ouml;nnen Sie eine
            Vervollst&auml;ndigung verlangen.</p>
          <p>d. Recht auf L&ouml;schung</p>
          <p>Sie k&ouml;nnen nach Art. 17 DS-GVO die L&ouml;schung Ihrer personenbezogenen Daten verlangen.</p>
          <p>e. Recht auf Einschr&auml;nkung der Verarbeitung</p>
          <p>Sie haben nach Art. 18 DS-GVO das Recht, eine Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen
            Daten zu verlangen.</p>
          <p>f. Recht auf Beschwerde</p>
          <p>Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen Datenschutzrecht
            verst&ouml;&szlig;t, haben Sie nach Ar. 77 Abs. 1 DS-GVO das Recht, sich bei einer
            Datenschutzaufsichtsbeh&ouml;rde eigener Wahl zu beschweren.</p>
          <p>Hierzu geh&ouml;rt auch die f&uuml;r den Verantwortlichen zust&auml;ndige Datenschutzaufsichtsbeh&ouml;rde:
          </p>
          <p>Landesbeauftragte f&uuml;r Datenschutz und Informationsfreiheit Nordrhein-Westfalen,</p>
          <p><a
              href="https://www.ldi.nrw.de/kontakt/ihre-beschwerde">https://www.ldi.nrw.de/kontakt/ihre-beschwerde</a>.
          </p>
          <p>g. Recht auf Daten&uuml;bertragbarkeit</p>
          <p>F&uuml;r den Fall, dass die Voraussetzungen des Art. 20 Abs. 1 DS-GVO vorliegen, steht Ihnen das Recht zu,
            sich Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf&uuml;llung eines Vertrags automatisiert
            verarbeiten, an sich oder an Dritte aush&auml;ndigen zu lassen. Die Erfassung der Daten zur Bereitstellung
            der Website und die Speicherung der Protokolldateien sind f&uuml;r den Betrieb der Internetseite zwingend
            erforderlich. Sie beruhen daher nicht auf einer Einwilligung nach Art. 6 Abs. 1 Buchstabe a DS-GVO oder auf
            einem Vertrag nach Art. 6 Abs. 1 Buchstabe b DS-GVO, sondern sind nach Art. 6 Abs. 1 Buchstabe f DS-GVO
            gerechtfertigt. Die Voraussetzungen des Art. 20 Abs. 1 DSGVO sind demnach insoweit nicht erf&uuml;llt.</p>
          <h1>II. Recht auf Widerspruch gem&auml;&szlig; Art. 21 Abs. 1 DS-GVO</h1>
          <p>Sie haben das Recht, aus Gr&uuml;nden, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die
            Verarbeitung Ihrer personenbezogenen Daten, die aufgrund von Artikel 6 Abs. 1 Buchstabe f DS-GVO erfolgt,
            Widerspruch einzulegen. Der Verantwortliche verarbeitet die personenbezogenen Daten dann nicht mehr, es sei
            denn, er kann zwingende schutzw&uuml;rdige Gr&uuml;nde f&uuml;r die Verarbeitung nachweisen, die die
            Interessen, Rechte und Freiheiten der betroffenen Person &uuml;berwiegen, oder die Verarbeitung dient der
            Geltendmachung, Aus&uuml;bung oder Verteidigung von Rechtsanspr&uuml;chen. Die Erfassung der Daten zur
            Bereitstellung der Website und die Speicherung der Protokolldateien sind f&uuml;r den Betrieb der
            Internetseite zwingend erforderlich.</p>
          <p>&nbsp;</p>
      </div>
      </v-card-text>

    </wgu-module-card>
  </v-fade-transition>
</template>

<script>
// the module card is a the template for a typical Wegue module
import ModuleCard from '../../../src/components/modulecore/ModuleCard';

export default {
  name: 'wgu-datenschutz',
  // make sure to register the 'Mapable' mixin
  components: {
    'wgu-module-card': ModuleCard
  },
  created () {
  },
  props: {
    icon: { type: String, required: false, default: 'star' }
  },
  mounted () {
    // console.log(this.$parent.$el.offsetHeight);
  },
  // here we define variables that are used in the HTML above
  data () {
    return {
      moduleName: 'wgu-datenschutz'
    };
  },
  methods: {
    /**
     * This function is called once the map is bound to the application
     */
  }
};
</script>

<!-- Here we do the styling of our module -->
<style scoped>

.card {
  overflow: auto;
  left: 60% !important;
  right: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);  /* zentriert Fenster, bei kleinen Bildschirmen dann*/
  /*
  height: 90%;
  width: 90%;
  */
  max-width: 90%;
  max-height: 90%;
  min-width: 250px;
  min-height: 250px;
  z-index: 55 !important;

}

.v-card > :last-child {
  overflow: auto;
  height: calc(100% - 70px);
}

h1 {
  font-size: 1.4em;
  line-height: 2rem;
  margin-bottom: 0.2em;
  color: #00508c;
}

h2 {
  font-size: 1.2em;
  margin-bottom: 6px;
  margin-top: 20px;
  color: #00508c;
}

h3 {
  font-size: 1.1em;
  margin-bottom: 0.2em;
  color: #00508c;
}

p {
  font-size: 1em;
  line-height: 1.5rem;
  margin-bottom: 10px; /* between paragraphs */
}

a {
    color: #007bC7 !important;
}

ul {
  padding-left: 4%;
  padding-bottom: 10px;
}

</style>
